<template>
  <div>
    <div class="dynamicBgWrapper">
      <div
        class="imgContainer"
        :style="
          this.resp.id != undefined
            ? { backgroundImage: `url(${imgEvento + this.resp.id})` }
            : {}
        "
      ></div>
    </div>
    <!-- Evento -->
    <div class="container customMargin">
      <div class="row g-0">
        <!-- info -->
        <div class="col-md-8">
          <div class="col-md-12">
            <div class="infoWrapper">
              <router-link to="/" class="headerLink"
                >← Regresar a eventos</router-link
              >
              <!-- <a class="headerLink" href="javascript:history.back()"
                >← Regresar a eventos</a
              > -->
              <br />
              <p class="titulo-evento">{{ this.resp.nombre }}</p>
              <p class="lugar-evento">{{ this.resp.zona }}</p>
            </div>
          </div>
          <!-- Info del evento -->
          <div class="col-md-12 bg_blanco p-5">
            <div class="row">
              <div class="col-md-6 pt-4">
                <p class="text-uppercase fw-bold mb-0">Lugar</p>
                <p>{{ this.resp.lugar }}</p>
              </div>
              <div class="col-md-6 pt-4">
                <p class="text-uppercase fw-bold mb-0">Fecha(s) y hora</p>
                <div class="fechasWrapper">
                  <div
                    v-for="(hrs, fechaInicio) in this.horarios"
                    :key="fechaInicio"
                    class="fechas"
                  >
                    <p>
                      {{ formatDate(hrs.fechaInicio, "dddd D MMMM YYYY ") }}
                    </p>
                    <p>{{ formatDate(hrs.fechaInicio, "   h:mm a ") }}</p>
                    <hr />

                    <!-- {{this.horarios}} -->
                  </div>
                </div>
              </div>
              <div class="divider mt-4"></div>
            </div>
            <div class="_">
              <div class="col-md-12">
                <p class="text-uppercase fw-bold mt-3">Acerca del evento</p>
                <p class="evento-descripcion">
                  {{ this.resp.descripcion }}
                </p>
              </div>
              <div
                class="col-md-12"
                v-if="
                  (this.resp.facebook && this.resp.facebook != '') ||
                  (this.resp.twitter && this.resp.twitter != '') ||
                  (this.resp.instagram && this.resp.instagram != '')
                "
              >
                <p class="text-uppercase fw-bold mt-3 mb-3">Redes Sociales</p>
                <ul class="eventos-redes">
                  <li v-show="this.resp.facebook && this.resp.facebook != ''">
                    <a
                      class="round-social"
                      :href="this.resp.facebook"
                      target="_blank"
                    >
                      <img src="../assets/img/face.svg" alt />
                    </a>
                  </li>
                  <li v-show="this.resp.instagram && this.resp.instagram != ''">
                    <a
                      class="round-social"
                      :href="this.resp.instagram"
                      target="_blank"
                    >
                      <img src="../assets/img/instagram.svg" alt />
                    </a>
                  </li>
                  <li v-show="this.resp.twitter && this.resp.twitter != ''">
                    <a
                      class="round-social"
                      :href="this.resp.twitter"
                      target="_blank"
                    >
                      <img src="../assets/img/twitter.svg" alt />
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col-md-12 mt-4">
                <p
                  v-show="this.resp.link && this.resp.link != ''"
                  class="text-uppercase fw-bold"
                >
                  Sitio Web
                </p>
                <a :href="this.resp.link" target="_blank">{{
                  this.resp.link
                }}</a>
              </div>
            </div>
          </div>
        </div>
        <!-- imagen -->
        <div class="col-md-4">
          <div
            class="imgPoster"
            :style="
              this.resp.id != undefined
                ? {
                    backgroundImage: `url(${
                      imgEvento + this.resp.id + '/1110'
                    })`,
                  }
                : {}
            "
          ></div>
          <div class="tipo-evento">
            <p>{{ this.categoria }}</p>
          </div>
        </div>
      </div>
      <!-- Mapa -->
      <div class="row">
        <div id="map" class="col-md-12">
          <GmapMap
            :center="{
              lat:
                this.lugares.find(
                  (lugar) => lugar.id === this.resp.idSubzona
                ) !== undefined
                  ? this.lugares.find(
                      (lugar) => lugar.id === this.resp.idSubzona
                    ).latitud
                  : 0,
              lng:
                this.lugares.find(
                  (lugar) => lugar.id === this.resp.idSubzona
                ) !== undefined
                  ? this.lugares.find(
                      (lugar) => lugar.id === this.resp.idSubzona
                    ).longitud
                  : 0,
            }"
            :zoom="18"
            map-type-id="roadmap"
            style="width: 100%; height: 400px"
            :options="options"
          >
            <GmapMarker
              :position="{
                lat:
                  this.lugares.find(
                    (lugar) => lugar.id === this.resp.idSubzona
                  ) !== undefined
                    ? this.lugares.find(
                        (lugar) => lugar.id === this.resp.idSubzona
                      ).latitud
                    : 0,
                lng:
                  this.lugares.find(
                    (lugar) => lugar.id === this.resp.idSubzona
                  ) !== undefined
                    ? this.lugares.find(
                        (lugar) => lugar.id === this.resp.idSubzona
                      ).longitud
                    : 0,
              }"
              :clickable="true"
              :draggable="false"
              @click="center = m.position"
              :icon="{ url: require('@/assets/img/marker.png') }"
            />
            />
          </GmapMap>
        </div>
      </div>
      <!-- detalles -->
      <div class="row">
        <div class="col p-4">
          <p class="text-center eventoTituloB">{{ this.resp.nombre }}</p>
          <p class="text-center evento-lugarB">{{ this.resp.lugar }}</p>
          <p class="text-center eventoDireccion">
            {{
              this.lugares.find((lugar) => lugar.id === this.resp.idSubzona) !==
              undefined
                ? this.lugares.find((lugar) => lugar.id === this.resp.idSubzona)
                    .domicilio
                : "" || ""
            }}
          </p>
          <p></p>
          <p></p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.testHeight {
  height: 300px;
}
.customMargin {
  margin-top: 135px;
}

.dynamicBgWrapper {
  width: 100%;
  position: absolute;
  height: 500px;
  z-index: -1;
  background: lightblue;
  overflow: hidden;
  top: 105px;

  .imgContainer {
    background-size: cover;
    filter: blur(5px);
    width: 100%;
    height: inherit;
    background-position: center;
  }
}
.infoWrapper {
  background: #2b2a25;
  display: flex;
  align-content: center;
  align-items: center;
  padding: 100px 50px;
  flex-wrap: wrap;

  .titulo-evento {
    color: white;
    font-weight: bold;
    font-size: 28px;
    text-transform: uppercase;
  }
  .lugar-evento {
    color: white;
    width: 100%;
    text-transform: uppercase;
  }
}
.imgPoster {
  width: 100%;
  height: 512px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  @media (max-width: 768.98px) {
    background-size: cover;
    background-position: center;
    height: 400px;
  }
}
.tipo-evento {
  background: #2b2a25;
  padding: 1rem;

  p {
    color: white;
  }
}
.headerLink {
  color: #76a8f3;
  width: 100%;
  transition: all ease 0.2s;
}
.fechasWrapper {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;

  hr {
    margin: 3px;
  }
  .fechas {
    p {
      text-transform: capitalize;
    }
    p:nth-child(2) {
      color: #03a9f4;
      margin-top: -6px;
    }
  }

  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 15px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 15px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: rgb(21, 36, 59);
    border-radius: 15px;
  }
}
</style>
<script>
import axios from "axios";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
export default {
  name: "Eventos",
  components: {},
  data() {
    return {
      id: null,
      categoria: null,
      resp: [],
      lugares: [],
      horarios: [],
      imgEvento:
        "https://egobierno2.aguascalientes.gob.mx/moviles/eventos/api/Eventos/image/",
      options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: true,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUI: false,
        suppressMarkers: true,
        styles: [
          {
            featureType: "administrative",
            elementType: "labels",
            stylers: [
              {
                visibility: "simplified",
              },
            ],
          },
          {
            featureType: "landscape.natural",
            elementType: "geometry.fill",
            stylers: [
              {
                visibility: "on",
              },
              {
                color: "#e0efef",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry.fill",
            stylers: [
              {
                visibility: "on",
              },
              {
                hue: "#1900ff",
              },
              {
                color: "#c0e8e8",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [
              {
                visibility: "simplified",
              },
            ],
          },
          {
            featureType: "poi.attraction",
            elementType: "labels",
            stylers: [
              {
                visibility: "simplified",
              },
            ],
          },
          {
            featureType: "poi.business",
            elementType: "labels",
            stylers: [
              {
                visibility: "off",
              },
              {
                lightness: "-11",
              },
              {
                saturation: "-24",
              },
              {
                color: "#b5afaf",
              },
              {
                weight: "0.14",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                lightness: 100,
              },
              {
                visibility: "simplified",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels",
            stylers: [
              {
                visibility: "on",
              },
              {
                lightness: "48",
              },
              {
                saturation: "-52",
              },
              {
                hue: "#ff0000",
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
              {
                visibility: "on",
              },
              {
                lightness: 700,
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "labels",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "all",
            stylers: [
              {
                color: "#7dcdcd",
              },
            ],
          },
        ],
      },
    };
  },
  created() {
    var that = this;

    that.id = this.$route.params.id;
    that.categoria = this.$route.params.categoria;

    axios
      .get(
        //"http://desarrolloweb.aguascalientes.gob.mx/moviles/eventos/api/Eventos/" + this.id
        "https://egobierno2.aguascalientes.gob.mx/moviles/eventos/api/Eventos/" +
          that.id
      )
      .then(function (response) {
        that.resp = response.data;
      })
      .catch(function (error) {
        location.reload();
      });

    axios
      .get(
        "https://egobierno2.aguascalientes.gob.mx/moviles/eventos/api/Datos/"
      )
      .then(function (response) {
        that.lugares = response.data.lugares;

        response.data.eventos.forEach(function (it, ix) {
          if (it.id.toString() === that.id) {
            that.horarios = it.horaios;
          }
        });
      })
      .catch(function (error) {});
  },
  computed: {},
  methods: {
    formatDate(v, fdate) {
      if (v) {
        return moment(String(v)).format(fdate);
        //  return moment(String(v)).format("DD/MM/YYYY hh:mm A");
      }
    },
  },
  mounted: function () {},
};
</script>
